import { IController } from 'angular';
import { NextRegentsAdminDate } from '../../../../../../ng2/shared/constants/next-regents-admin-date.constant';
import { ISdcStore } from '../../../../flux/sdc-store.interface';

export class RegentsPrepWizardTransferCtrl implements IController {
  static $inject: string[] = ['$scope', 'SpinnerModal', 'SDCStore', 'NavService'];

  public uiReady;
  public nextRegentsAdminDate;
  public currentUser;

  constructor(private $scope, private SpinnerModal, private SDCStore: ISdcStore, private NavService) {}

  $onInit() {
    this.nextRegentsAdminDate = NextRegentsAdminDate;

    this.$scope.$listenTo(this.SDCStore, ['ui', 'isLoading'], () => {
      const isLoading = this.SDCStore.getUiState().isLoading;
      if (!isLoading) {
        this.SpinnerModal.deactivateSpinner();
        this.uiReady = true;
      }
    });
  }

  public openSideNav() {
    this.NavService.openNav('left');
  }
}
